import {Button, Col, Icon, message, Modal, Row, Table, Upload} from 'antd'
import React, {useEffect, useState} from 'react'
import {getOptionsPromise, importSelectedPromise} from '../../promises'
import {ReportService} from '../../../../services'
import {useTranslation} from "react-i18next";

const EditRowRisk = ({editCode, modalTitle, handleCancel}) => {

  const [options, setOptions] = useState(null);
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [exportLoading, setExportLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState();
  const { t } = useTranslation();

  const { confirm } = Modal;

  useEffect(() => {
      refreshTable()
    }, []);

    const refreshTable = () => {
      getOptionsPromise(editCode).then(response =>{
        if (response){
        setSelectedOptions(response.filter(op => op.selected === "X").length)
        setOptions(response)
        setIsTableLoading(false)
        }else{
          message.error("No se pudieron cargar los datos")
        }
      })
    }

    const optionColumns = [
      {
        title: "Elemento",
        dataIndex: 'name',
        width: '85%'
      },
      // {
      //   title: "Sugerido",
      //   width: '25%'
      // },
      {
        title: "Seleccionado",
        dataIndex: 'selected',
        render: (text) => {
          return text === "X" ? 'Si' : ""
        },
        width: '15%'
      }

    ]

    const propsUpload = {
      accept: ".xlsx, .xls",
      beforeUpload: file => {
        if(file) {
        const isExcel =
            file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            file.type === "application/vnd.ms-excel";

        if (!isExcel) {
          message.error("Solo se permiten archivos Excel");
          return false;
        }

        const maxSizeBytes = 500 * 1024;
        if (file.size > maxSizeBytes) {
          message.error("Error: El archivo supera el tamaño permitido (500Kb)");
          return false;
        }

          confirm({
            title: (
                <>
                  El listado de riesgo <span style={{ textDecorationLine: 'underline' }}>{modalTitle}</span> será reemplazado, ¿desea continuar?
                </>
            ),
            okText: "Si",
            cancelText: "No",
            onOk: async () => {
              await handleImport(file)
            },
            onCancel() {
              return
            },
          });
        }
        return false
      },
      multiple: false,
      showUploadList: false
    }

    const handleExport = async () => {
      setExportLoading(true)
      await ReportService.read('/excelOptionsRisk', {option: editCode}, null, modalTitle+'.xlsx')
      setExportLoading(false)
    }

    const handleImport =  async (file) => {
      setImportLoading(true)
      const formData = new FormData()
          formData.append('file', file)
          formData.append('option', editCode)
          setIsTableLoading(true)
      await importSelectedPromise(formData).then(response => {
        setImportLoading(false)
        if(response === "OK") {
          setIsTableLoading(false)
          refreshTable()
          message.success("Se importó el archivo correctamente")
        }else if(response === "ERROR_SIZE"){
          message.error("Error: El archivo supera el tamaño permitido (500Kb)")
        }else if(response === "EXTENSION_ERROR"){
          message.error("Error: formato no permitido")
        }else{
          message.error("Ha ocurrido un error al importar")
        }
      })
    }

    return (
        <Modal
        title={modalTitle}
        visible={true}
        footer={false}
        onCancel={handleCancel}
        width={800}
        style={{top:10}}
      >
        <Row gutter={[0, 10]}>
          <Col span={24}>
            <h3>Actualmente tiene seleccionado {selectedOptions ?? <Icon type="loading" />} elementos de riesgo, a continuación se presenta el detalle.</h3>
          </Col>
        </Row>
        <Row gutter={[0, 15]}>
          <Col span={1}>
            1.
          </Col>
          <Col span={18}>
            Para modificar el listado, descargue el archivo Excel y marque con una "x" los elementos que desea incorporar.
          </Col>
          <Col span={5} style={{textAlign: 'right'}}>
            <Button loading={exportLoading} onClick={() => {handleExport()}}>{!exportLoading && <Icon type="arrow-down" />} Exportar </Button>
          </Col>
        </Row>
        <Row gutter={[0, 20]}>
          <Col span={1}>
            2.
          </Col>
          <Col span={18}>
            Una vez realizados los cambios, puede subir el archivo actualizado. Recuerde que el nuevo archivo reemplazará el listado anterior y no debe contener saltos de filas para asegurar una carga exitosa.
          </Col>
          <Col span={5} style={{textAlign: 'right'}}>
            <Upload {...propsUpload}>
              <Button loading={importLoading}>{!importLoading && <Icon type="arrow-up" />} Importar </Button>
            </Upload>
          </Col>
        </Row>
          <Row>
            <Table size="small" dataSource={options} columns={optionColumns} pagination={false} loading={isTableLoading} scroll={{ y: 400 }}/>
          </Row>
      </Modal>
    );
}

export default EditRowRisk;
